import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-evaluate',
  templateUrl: './job-evaluate.component.html',
  styleUrls: ['./job-evaluate.component.less']
})
export class JobEvaluateComponent implements OnInit {
  @Input() currentJob: any;
  @Input() code: any; // 0表示管理员评价 1表示查看评价信息 2表示报修人评价
  adminDesc = '';
  callerDesc = '';
  callerStar = 10;
  callerAttitudeStar = 10;
  callerQualityStar = 10;
  adminStar = 10;
  adminAttitudeStar = 10;
  adminQualityStar = 10;

  constructor() { }

  ngOnInit(): void {
    if (!this.isEmpty(this.currentJob.starEvaluationAdmin)){
      // tslint:disable-next-line:radix
      this.adminStar = parseInt(this.currentJob.starEvaluationAdmin);
    }
    if (!this.isEmpty(this.currentJob.starAttitudeEvaluationAdmin)){
      // tslint:disable-next-line:radix
      this.adminAttitudeStar = parseInt(this.currentJob.starAttitudeEvaluationAdmin);
    }
    if (!this.isEmpty(this.currentJob.starQualityEvaluationAdmin)){
      // tslint:disable-next-line:radix
      this.adminQualityStar = parseInt(this.currentJob.starQualityEvaluationAdmin);
    }
    if (!this.isEmpty(this.currentJob.starEvaluationCaller)){
      // tslint:disable-next-line:radix
      this.callerStar = parseInt(this.currentJob.starEvaluationCaller);
    }
    if (!this.isEmpty(this.currentJob.starAttitudeEvaluationCaller)){
      // tslint:disable-next-line:radix
      this.callerAttitudeStar = parseInt(this.currentJob.starAttitudeEvaluationCaller);
    }
    if (!this.isEmpty(this.currentJob.starQualityEvaluationCaller)){
      // tslint:disable-next-line:radix
      this.callerQualityStar = parseInt(this.currentJob.starQualityEvaluationCaller);
    }
    if (!this.isEmpty(this.currentJob.textEvaluationAdmin)){
      this.adminDesc = this.currentJob.textEvaluationAdmin;
    }
    if (!this.isEmpty(this.currentJob.textEvaluationCaller)){
      this.callerDesc = this.currentJob.textEvaluationCaller;
    }
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
        return true;
    } else {
        return false;
    }
  }

}
